import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltipContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      fontWeight: 400,
      color: theme.palette.text.primary,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
  }),
);

export default useStyles;
